import React from "react";
import Modal from "react-modal";
import { useDispatch } from "react-redux";
import ReactMarkdown from "react-markdown";
import { ReactComponent as CloseIcon } from "../../../../../assets/icons/CloseIcon.svg";
import CardLayout from "../../../../common/cardLayout/CardLayout";
import {
  fetchPatientPCLogic,
  pinContentForPatientLogic,
} from "../../../../../store/features/patient/pinnedContentSlice";
import { notify, normalizeMediaType } from "../../../../../util/helpers";

const customStyles = {
  overlay: {
    backgroundColor: "rgba(11, 17, 71, 0.5)",
  },
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    marginRight: "-50%",
    borderRadius: "16px",
    transform: "translate(-50%, -50%)",
    width: "70%",
    height: "80vh",
    overflowY: "none",
  },
};
const ViewPinnedContentV2 = ({
  modalIsOpen,
  setIsOpen,
  data,
  patientID,
  modalTitle = "Dual Login Detected",
}) => {
  const dispatch = useDispatch();
  const normalizedType = normalizeMediaType(data?.media_type);
  const extractIframe = (htmlString)=> {
    const iframeRegex = /<iframe.*?<\/iframe>/g;
    const matches = htmlString.match(iframeRegex);
    return matches ? matches[0] : null;
  }
  const handleNewPinContent = () => {
    // console.log("data: ", data);
    // return;
    
    pinContentForPatientLogic({
      identifier: data.id,
      patient: patientID.toString(),
      type: data.media_type || (data?.Video ? "videos" : "Videos"),
    })
      .then((res) => {
        if (res.status === 200 || res.status === 201) {
          notify("Content pinned successfully!");
          dispatch(fetchPatientPCLogic(patientID));
          setIsOpen(false);
        }
      })
      .catch((err) => {
        console.log("Error pinning content", err);
        notify("Something went wrong!", "error");
      });
  };
  Modal.setAppElement("#root");
  function closeModal(e) {
    e.stopPropagation();
    setIsOpen(false);
  }
  return (
    <Modal
      isOpen={modalIsOpen}
      onRequestClose={closeModal}
      style={customStyles}
      contentLabel=""
    >
      <div className="container-fluid">
        <button
          style={{
            position: "absolute",
            right: "15px",
            border: "0px",
            fontFamily: "DM Sans",
            backgroundColor: "transparent",
          }}
          onClick={closeModal}
        >
          <CloseIcon />
        </button>
        <CardLayout className="p-3">
          <div className="container-fluid">
            <h3 className="text-start">{data?.Title || modalTitle}</h3>
            <br />
            <div className="container-fluid">
              <>
                {normalizedType === "Videos" && (
                  <div className="preview-section">
                    {data?.Embed ? (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: data?.Embed,
                        }}
                      />
                    ) : (data?.Video?.url || data?.video_source) ? (
                      <video
                        controls
                        width="100%"
                        style={{ maxHeight: "50vh", borderRadius: "8px" }}
                        src={data?.Video?.url || data?.video_source}
                      >
                        Your browser does not support the video tag.
                      </video>
                    ) : (
                      <p className="text-muted">No video preview available.</p>
                    )}
                  </div>
                )}
                
                {/* {data?.media_type === "TikToks" && (
                          <div
                            className="preview-section"
                            dangerouslySetInnerHTML={{
                              __html: selectedContent?.value?.TikTokEmbed,
                            }}
                          />
                        )} */}

                {normalizedType === "Audio" && (
                  <div
                    style={{
                      width: "100%",
                      height: "50lvh",
                      background: `url(${
                        data?.Thumbnail?.url ||
                        data?.classification?.Image?.formats?.thumbnail?.url ||
                        data?.Thumbnail?.formats?.thumbnail?.url ||
                        "https://placehold.co/600x400?text=."
                      }) no-repeat center/cover`,
                    }}
                  >
                    <video
                      width="100%"
                      style={{
                        padding: "0px 50px",
                        height: "25vh",
                      }}
                      controls
                      name="media"
                    >
                      <source src={data?.Audio?.url} type="audio/mpeg" />
                    </video>
                  </div>
                )}

                {normalizedType === "Article" && (
                  <>
                    <div style={{ display: "flex", alignItems: "flex-start" }}>
                      <div
                        style={{
                          padding: "0px 10px",
                          height: "50lvh",
                          width: "50%",
                        }}
                      >
                        <div
                          style={{
                            width: "100%",
                            height: "50lvh",
                            background: `url(${
                              data?.Picture?.url ||
                              data?.Picture?.formats?.thumbnail?.url ||
                              "https://placehold.co/600x400?text=."
                            }) no-repeat center/cover`,
                          }}
                        ></div>
                      </div>

                      <div
                        className="pb-4"
                        style={{
                          height: "50lvh",
                          width: "50%",
                          overflowY: "scroll",
                        }}
                      >
                        <ReactMarkdown children={data?.Body} />
                      </div>
                    </div>
                  </>
                )}
              </>
            </div>
          </div>
          <div
            style={{ gap: "10px" }}
            className="container-fluid d-flex justify-content-end mt-4 px-2"
          >
            <button
              className="btn alternative-btn"
              style={{ width: "25%" }}
              onClick={closeModal}
            >
              Cancel
            </button>
            <button
              style={{ width: "25%" }}
              className="primary-btn"
              onClick={handleNewPinContent}
            >
              Pin Content
            </button>
          </div>
        </CardLayout>
      </div>
    </Modal>
  );
};

export default ViewPinnedContentV2;
